import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { breakpointUpTo } from 'utils/breakpoints'
import SVG from 'react-inlinesvg'
import { getOneLinkUrl } from '../../utils/appsflyerOneLink'

const StyledImg = styled(SVG)`
  ${({ theme }) => breakpointUpTo(theme.breakpoints.sm)} {
    width: 140px;
  }
`
type ButtonProps = {
  link: string
  icon: string
  className?: string
}

export const StoreButton = ({ link, icon, className }: ButtonProps) => {
  const [oneLink, setOneLink] = useState<string | undefined>()
  const [counter, setCounter] = useState()

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter(window.AF_SMART_SCRIPT)
    }, 500)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    if (counter !== undefined) {
      setOneLink(getOneLinkUrl())
    }
  }, [counter])

  return (
    <a
      href={oneLink ? oneLink : link}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      <StyledImg src={icon} />
    </a>
  )
}
